import baseApi from '@/api/base.js'

const state = {
  provinceArray: [],
  cityArray: [],
  countyArray: [],
  ApiEndpoint: {
    elearningCourseUrl: 'https://elearning.touch-spring.com/ThirdApi/LearnCourse',
    fileUrl: process.env.VUE_APP_FILE_SERVER,
    ecatSiteUrl: 'https://mobilecat.bosch-trading.com.cn',
    tssUrl: 'https://rbaatssuat.uxicp.com/portal/',
    qrSiteUrl: 'https://qr.bosch-extra.com.cn/'
  }
}

const actions = {
  base_a_provinceData ({ commit }) {
    return new Promise(resolve => {
      baseApi.queryProvinceData().then(
        res => {
          commit('base_m_provinceData', res.data.resultData.provinceList)
          resolve()
        }
      )
    })
  },
  base_a_cityData ({ commit }, payload) {
    if (!payload.params.provinceCode) {
      commit('base_m_cityData', [])
      commit('base_m_countyData', [])
    }
    return new Promise(resolve => {
      baseApi.queryCityData(payload.params).then(
        res => {
          commit('base_m_cityData', res.data.resultData.cityList)
          resolve()
        }
      )
    })
  },
  base_a_countyData ({ commit }, payload) {
    if (!payload.params.cityCode) {
      commit('base_m_countyData', [])
      return
    }
    return new Promise(resolve => {
      baseApi.queryCountyData(payload.params).then(
        res => {
          commit('base_m_countyData', res.data.resultData.countyList)
          resolve()
        }
      )
    })
  }
}

const mutations = {
  base_m_provinceData (state, provinceList) {
    state.provinceArray = provinceList
  },
  base_m_cityData (state, cityList) {
    state.cityArray = cityList
  },
  base_m_countyData (state, countyList) {
    state.countyArray = countyList
  }
}

export default {
  state,
  actions,
  mutations
}
